import api from '@/utils/httpClient';
import { useQuery } from 'react-query';
import { TreatmentMappingDto } from '../dtos/TreatmentMapping';
import { treatmentMappingKeys } from '../TreatmentHistory/treatmentMapping.keys';

async function getTreatmentMappings(
  cancerPathologyIds: string[],
  treatmentTypeId: string
) {
  const cancerPathologyIdsFilter = `cancerPathologyId==${cancerPathologyIds.join(
    '|'
  )}`;
  const treatmentTypeIdFilter = `treatmentTypeId==${treatmentTypeId}`;
  return api
    .get(`/api/treatmentmappings`, {
      params: {
        Filters: `${cancerPathologyIdsFilter},${treatmentTypeIdFilter}`,
      },
    })
    .then((response) => {
      const parsedResponse = response.data as TreatmentMappingDto[];
      return parsedResponse;
    });
}

function useGetTreatmentMappings(
  cancerPathologyIds: string[],
  treatmentTypeId: string
) {
  return useQuery(
    treatmentMappingKeys.list(cancerPathologyIds.join(','), treatmentTypeId),
    async () => {
      if (treatmentTypeId) {
        return getTreatmentMappings(cancerPathologyIds, treatmentTypeId);
      }
    }
  );
}

export { useGetTreatmentMappings };
